module.exports = __webpack_public_path__ + "24547c79293a37ba6e69ab4d9dad0a6d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau06.jpg
// module id = 662
// module chunks = 0